
namespace GeniuzPOS.Administration {

    import fld = PsPosFuncRow.Fields;
    
    @Serenity.Decorators.registerClass()
    export class PsPosFuncGrid extends Serenity.EntityGrid<PsPosFuncRow, any> {
        protected getColumnsKey() { return PsPosFuncColumns.columnsKey; }
        protected getDialogType() { return PsPosFuncDialog; }
        protected getIdProperty() { return PsPosFuncRow.idProperty; }
        protected getInsertPermission() { return PsPosFuncRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPosFuncRow.localTextPrefix; }
        protected getService() { return PsPosFuncService.baseUrl; }

        private pendingChanges: Q.Dictionary<any> = {};

        constructor(container: JQuery) {
            super(container);

            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
        }

        protected getButtons()
        {
            var buttons = super.getButtons();

            buttons.push({
                title: 'Save Changes',
                cssClass: 'apply-changes-button disabled',
                onClick: e => this.saveClick(),
                separator: true
            });

            return buttons;
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            this.setSaveButtonState();
            return super.onViewProcessData(response);
        }

        
         private numericInputFormatter(ctx) {
            if ((ctx.item as Slick.NonDataRow).__nonDataRow)
                return Q.htmlEncode(Q.formatNumber(ctx.value, '#0.##'));
            
            var klass = 'edit numeric';
            var item = ctx.item as PsPosFuncRow;
            var pending = this.pendingChanges[item.Id];

            if (pending && pending[ctx.column.field] !== undefined) {
                klass += ' dirty';
            }

            var value = this.getEffectiveValue(item, ctx.column.field) as number;

            return "<input type='text' class='" + klass + 
                "' data-field='" + ctx.column.field + 
                "' value='" + Q.formatNumber(value, '0.##') + "'/>";
        }

        private stringInputFormatter(ctx) {
            if ((ctx.item as Slick.NonDataRow).__nonDataRow)
                return Q.htmlEncode(ctx.value);
            
            var klass = 'edit string';
            var item = ctx.item as PsPosFuncRow;
            var pending = this.pendingChanges[item.Id];
            var column = ctx.column as Slick.Column;

            if (pending && pending[column.field] !== undefined) {
                klass += ' dirty';
            }

            var value = this.getEffectiveValue(item, column.field) as string;

            return "<input type='text' class='" + klass +
                "' data-field='" + column.field +
                "' value='" + Q.attrEncode(value) + 
                "' maxlength='" + column.sourceItem.maxLength + "'/>";
        }



        /**
         * Sorry but you cannot use LookupEditor, e.g. Select2 here, only possible is a SELECT element
         */
         private selectFormatter(ctx: Slick.FormatterContext, idField: string, lookup: Q.Lookup<any>) {
            if ((ctx.item as Slick.NonDataRow).__nonDataRow)
            return Q.htmlEncode(ctx.value);
            
            var klass = 'edit';
            var item = ctx.item as PsPosFuncRow;
            var pending = this.pendingChanges[item.Id];
            var column = ctx.column as Slick.Column;

            if (pending && pending[idField] !== undefined) {
                klass += ' dirty';
            }

            var value = this.getEffectiveValue(item, idField);
            var markup = "<select class='" + klass +
                "' data-field='" + idField + 
                "' style='width: 100%; max-width: 100%'>";
            for (var c of lookup.items) {
                let id = c[lookup.idField];
                markup += "<option value='" + Q.attrEncode(id) + "'"
                if (id == value) {
                    markup += " selected";
                }
                markup += ">" + Q.htmlEncode(c[lookup.textField]) + "</option>";
            }
            return markup + "</select>";
        }

        private getEffectiveValue(item, field): any {
            var pending = this.pendingChanges[item.Id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }

            return item[field];
        }

        protected getColumns(){
            var columns = super.getColumns();
            var num = ctx => this.numericInputFormatter(ctx);
            var str = ctx => this.stringInputFormatter(ctx);

            Q.first(columns, x => x.field === 'FuncKeyLable').format = str; 

            var funclevel = Q.first(columns, x => x.field === fld.FunLevel);
            funclevel.referencedFields = [fld.FunLevel];
            funclevel.format = ctx => this.selectFormatter(ctx, fld.FunLevel, PsFuncLevelRow.getLookup());

            var keymapshiftcode = Q.first(columns, x => x.field === fld.KbMapShiftCode);
            keymapshiftcode.referencedFields = [fld.KbMapShiftCode];
            keymapshiftcode.format = ctx => this.selectFormatter(ctx, fld.KbMapShiftCode, PsFuncKbMapShiftCodeRow.getLookup());

            var kbmapkeycode = Q.first(columns, x => x.field === fld.KbMapKeyCode);
            kbmapkeycode.referencedFields = [fld.KbMapKeyCode];
            kbmapkeycode.format = ctx => this.selectFormatter(ctx, fld.KbMapKeyCode, PsFuncKbMapKeyCodeRow.getLookup());

            //Q.first(columns, x => x.field === fld.UnitPrice).format = num;

            // var usege = Q.first(columns, x => x.field === fld.FuncUsage);
            // usege.referencedFields = [fld.FuncUsage];
            // usege.format = ctx => this.numericInputFormatter(ctx, fld.FuncUsage);

            

            return columns;
        }

        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var pending = this.pendingChanges[item.Id];

            var effective = this.getEffectiveValue(item, field);
            var oldText: string;
            if (input.hasClass("numeric"))
                oldText = Q.formatNumber(effective, '0.##');
            else
                oldText = effective as string;

            var value;
            if (field === '') {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass("numeric")) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else
                value = text;

            if (!pending) {
                this.pendingChanges[item.Id] = pending = {};
            }

            pending[field] = value;
            item[field] = value;
            this.view.refresh();

            if (input.hasClass("numeric"))
                value = Q.formatNumber(value, '0.##');

            input.val(value).addClass('dirty');

            this.setSaveButtonState();
        }

        private setSaveButtonState() {
            this.toolbar.findButton('apply-changes-button').toggleClass('disabled',
                Object.keys(this.pendingChanges).length === 0);
        }

        private saveClick() {
            if (Object.keys(this.pendingChanges).length === 0) {
                return;
            }

            // this calls save service for all modified rows, one by one
            // you could write a batch update service
            var keys = Object.keys(this.pendingChanges);
            var current = -1;
            var self = this;

            (function saveNext() {
                if (++current >= keys.length) {
                    self.refresh();
                    return;
                }

                var key = keys[current];
                var entity = Q.deepClone(self.pendingChanges[key]);
                entity.Id = key;
                Q.serviceRequest(PsPosFuncService.Methods.Update, {
                    EntityId: key,
                    Entity: entity
                }, (response) => {
                    delete self.pendingChanges[key];
                    saveNext();
                });
            })();
        }
    }
}